/*
 * 1-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * ActionBarImage.tsx - Logo to display on right side of nav bar.
 */

import { View } from 'react-native';
import SvgImage from './components/SvgImage';
import { logoBackground } from './colours';

const LOGO_WRM_ASPECT_RATIO = 111/40;

const ActionBarImage = ({height}: {height: number}) => {
  const svgHeight = height * 0.6;
  const padding = height * 0.2;
  const svgWidth = svgHeight * LOGO_WRM_ASPECT_RATIO;
  const width = svgWidth + 2*padding;

  return (
    <View style={{
      height,
      width,
      padding,
      backgroundColor: logoBackground,
      borderRadius: height/10,
      marginRight: height/4,
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <SvgImage
        source={require('./assets/images/logo-wrm-white.svg')}
        height={svgHeight}
        width={svgWidth}
      />
    </View>
  );
};

export default ActionBarImage;
